import {
  Church, Music, Handshake, Baby, Video, UtensilsCrossed, HandHeart,
  HandCoins, Users, ClipboardList, BookOpen, HandHelping, Clock, MapPin, UserPlus, Shirt,
  Wallet,
} from 'lucide-react';

export const ICONS = {
  church: Church,
  wallet: Wallet,
  music: Music,
  handshake: Handshake,
  baby: Baby,
  video: Video,
  'utensils-crossed': UtensilsCrossed,
  'hand-heart': HandHeart,
  'hand-coins': HandCoins,
  users: Users,
  'clipboard-list': ClipboardList,
  'book-open': BookOpen,
  'hand-helping': HandHelping,
  clock: Clock,
  'map-pin': MapPin,
  'user-plus': UserPlus,
  shirt: Shirt,
};

export function CardIcon({ name, className }) {
  const Icon = ICONS[name];
  return Icon ? <Icon className={className} strokeWidth={1.5} /> : null;
}
